import { createSlice } from '@reduxjs/toolkit';

export const stickerSlice = createSlice({
    name: 'sticker',
    initialState: null,
    reducers: {
        stickerSet: (state, action) => {
            return action.payload;
        }
    }
});

export const { stickerSet } = stickerSlice.actions;
export default stickerSlice.reducer;
